export default function R_Nested_If() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Nested_If Component</h1>
      <p>This is the R_Nested_If tutorial section.</p>
    </div>
  );
}
